import type { FhhState } from '../fhhDefaultState';

export const useFhhValidation = (state: Partial<FhhState>, pristine: boolean) => {
    const hasTyped = !!state.destination?.trim();
    const hasSelected = !!state.destinationData;

    const validateState = (): boolean => !hasTyped || hasSelected;

    const invalid = {
        startDate: !pristine && !!state.endDate && !state.startDate,
        endDate: !pristine && !!state.startDate && !state.endDate,
        destination: !pristine && hasTyped && !hasSelected,
    };

    return { validateState, invalid };
};
